import React, { useEffect, useRef, useState } from "react";

const STATS = [
	{ value: "9", label: "Pipeline Stages" },
	{ value: "20+", label: "ROI Calculator Variables" },
	{ value: "8", label: "Team Roles" },
	{ value: "<2s", label: "Sync Speed" },
];

const PLATFORMS = [
	"Zillow",
	"Redfin",
	"Realtor.com",
	"Homes.com",
];

export function StatsSection() {
	const ref = useRef<HTMLDivElement>(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.3 },
		);
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<section ref={ref} className="py-20 md:py-28">
			<div className="mx-auto max-w-7xl px-6">
				{/* Stats Grid */}
				<div className="grid grid-cols-2 gap-6 md:grid-cols-4">
					{STATS.map((stat, i) => (
						<div
							key={stat.label}
							className={`text-center ${visible ? "animate-counter-up" : "opacity-0"}`}
							style={{ animationDelay: `${i * 150}ms` }}
						>
							<div className="text-4xl font-bold text-white md:text-5xl">
								{stat.value}
							</div>
							<p className="mt-2 text-sm text-zinc-400">{stat.label}</p>
						</div>
					))}
				</div>

				{/* Platform Logos */}
				<div className="mt-16 text-center">
					<p className="mb-6 text-sm text-zinc-500">
						Save listings from the platforms you already browse
					</p>
					<div className="flex flex-wrap items-center justify-center gap-8">
						{PLATFORMS.map((name) => (
							<span
								key={name}
								className="text-lg font-semibold text-zinc-600 transition-colors hover:text-zinc-400"
							>
								{name}
							</span>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
